module.exports = __webpack_public_path__ + "static/media/3.253e87b3.JPG";